import { sortDropdownOptions } from "./dropdown-sorting";

export function sortHaulierOptions(options) {
  const promotedOptions = ["NESTLE OWN FLEET COLUMN"];

  return sortDropdownOptions(options, promotedOptions);
}
